import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { setScrutinyActiveTab } from '../../appconfig/AppHelper';

export const ScrutinyTab = (mainTabLabel: any) => {
    const router = useNavigate();

    const [scrutinyTab, setScrutinyTab] = useState<any>(null);

    useEffect(() => {
        // Get Role
        const roleName = localStorage.getItem('role');
        if (roleName && !window.cn(roleName)) {
            let activeTab = setScrutinyActiveTab(roleName);
            setScrutinyTab(activeTab);
        }
    }, []);

    const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';
    
    const HRitems: MenuItem[] = [
        {
            label: 'Scrutiny (Gujarat)',
            command: () => {
                router(`/app/scrutiny/fresh-registration-scrutiny/${window.btoa(scrutinyTab)}`);
            }
        },
        {
            label: 'Scrutiny (Other State)',
            command: () => {
                router(`/app/scrutiny/other-state-scrutiny/${window.btoa(scrutinyTab)}`);
            }
        },
        {
            label: 'Scrutiny (Transfer To Gujarat)',
            command: () => {
                router(`/app/scrutiny/transfer-to-gujarat-scrutiny/${window.btoa(scrutinyTab)}`);
            }
        },
        {
            label: 'Scrutiny (Transfer DD/DNH)',
            command: () => {
                router(`/app/scrutiny/transfer-to-dd-dnh-scrutiny/${window.btoa(scrutinyTab)}`);
            }
        },
        {
            label: 'Scrutiny (Degree Additional)',
            command: () => {
                router(`/app/scrutiny/degree-addition-scrutiny/${window.btoa(scrutinyTab)}`);
            }
        },
        {
            label: 'Scrutiny (Re Entry)',
            command: () => {
                router(`/app/scrutiny/re-entry-scrutiny/${window.btoa(scrutinyTab)}`);
            }
        },
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    // Convert string to Set 
    const assignedMenuSet = new Set(
        assignedMenu.split(',').map((item: string) => item.trim())
    );

    // Filter HRitems by checking if label exists in assignedMenuSet
    const filteredHRitems = HRitems.filter(
        item => item.label && assignedMenuSet.has(item.label)
    );

    useEffect(() => {
        if (filteredHRitems.length > 0 && mainTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == mainTabLabel.mainTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [filteredHRitems]);
    
    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />
        </>
    );
};
